import React from 'react';
import { Popup } from '../../components/Popup';

export const InfoPopup = ({ 
    isOpen, 
    closePopup = () => {}, 
    content = { title: '', content: <React.Fragment></React.Fragment> },
    isDismissableBackground = true
}) => {
    return (
        <React.Fragment>
            {isOpen && <Popup
                close={closePopup}
                title={content.title}
                buttonText="Ok! Ho capito"
                isDismissableBackground={isDismissableBackground}
            >
                <div style={{ padding: '8px' }}>
                    {content.content}
                </div>
            </Popup>}
        </React.Fragment>
    )
}